const locale = {
  HEADER_ARIA_LABEL: 'Main navigation header',
  NAV_ARIA_LABEL: 'Primary navigation',
  MENU_BUTTON_ARIA_LABEL: 'Open navigation menu',
  NOTIFICATIONS_ARIA_LABEL: 'Notifications',
  ACCOUNT_MENU_ARIA_LABEL: 'Account menu',
  IKIGAI_BUTTON_LABEL: 'Career finder',
};

export default locale;
